/**
 * A global namespace for `document.head`.
 */
const { head: documentHead } = document;
export default documentHead;
